import React from 'react'
import styles from './styles.css'
import fireEvent from 'App/helpers/globalEvents/fireEvent'
import useMutate from 'apollo-hooks/lib/useMutate'
import gql from 'graphql-tag'

export default function CallOrder(props) {
  const {order} = props
  const {phone} = order.points[1]

  const mutate = useMutate()

  const logCall = async () => {
    try {
      await mutate({
        mutation: gql`
          mutation logCall($orderId: ID, $phone: String) {
            logCall(orderId: $orderId, phone: $phone)
          }
        `,
        variables: {orderId: order._id, phone}
      })
    } catch (error) {
      alert(error.message)
    }
  }

  const call = () => {
    logCall()
    fireEvent('makeCall', {phoneNumber: phone})
  }

  return (
    <div className={styles.container}>
      <a onClick={call}>Llamar al cliente {phone}</a>
    </div>
  )
}
